import React, { useState, useEffect } from "react";
import styled, { css, keyframes } from "styled-components";

export default function MenuIcon() {
  return (
    <svg
      className="fill-current"
      xmlns="http://www.w3.org/2000/svg"
      height="24"
      viewBox="0 0 24 24"
      width="24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
    </svg>
  );
}
